<template>
  <div>
    <div class="event-top">
      <div class="wrap" id="g-contents">
        <img src="../../assets/images/event/icon-gift.png" alt=""/>
        <p class="event-top-text">wavve의 다양한 이벤트를 만나보세요.</p>
      </div>
    </div><!--ticket-top//-->

    <div class="nav-2depth-wrap event-2depth">
      <div class="inner-wrap">
        <ul>
          <li v-for="(menu, index) in menuList" :class="selectedClass(menu.title)" :key="'menu__'+index">
            <a :to="menu.path" :key="'event_sub_menu' + index" @click="goUrl(menu.path)">{{menu.menu}}</a>
          </li>
        </ul>
      </div>
    </div><!--nav-2depth-wrap//-->
  </div>
</template>

<script>

import { UPDATE_EVENT_LIST_CONTENT } from '@/common/resources/const'

export default {
  data () {
    return {
      menuList: [
        { menu: '진행중 이벤트', title: 'event', path: '/customer/event_list' },
        { menu: '당첨자 발표', title: 'board', path: '/customer/event_board_list' }
      ]
    }
  },
  methods: {
    selectedClass (title) {
      return title === this.$route.meta.menu ? 'nav-depth-on' : ''
    },
    goUrl (url) {
      this.$events.$emit(UPDATE_EVENT_LIST_CONTENT)
      this.$router.push(url)
    }
  }
}
</script>
